import { ecorEnv } from '@/../environments/environment';
import { ParadataEventEnum, ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { AppSettingsService } from '@/common/services/app-settings.service';
import { SurveyViewsInstanceBaseComponent } from '@/surveys/components/survey-views-instance-base/survey-views-instance-base.component';
import { SurveyViewsInstanceService } from '@/surveys/services/survey-views-instance.service';
import { FilingStatusDialogService } from '@/surveys/services/filing-status-dialog.service';
import { RequestExtensionDialogService } from '@/surveys/services/request-extension-dialog.service';
import { ShareSurveyAccessDialogService } from '@/surveys/services/share-survey-access-dialog.service';
import { EventService } from '@/surveys/services/event.service';
import { Component, HostListener, Inject, OnDestroy, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DueSurveyDialogData } from '../../dialogs-data/due-survey-dialog-data';
import { WINDOW } from '@/window';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';
import { GridViewInstanceComponent } from '@/surveys/components/survey-views/grid-view/grid-view-instance/grid-view-instance.component';

@Component({
    selector: 'due-add-survey-dialog',
    templateUrl: './due-survey-dialog.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatFormFieldModule,
        NgxMaskModule,
        MatInputModule,
        GridViewInstanceComponent,
        ReactiveFormsModule
    ],
    providers: [
        ParadataEventService,
        RequestExtensionDialogService,
        ShareSurveyAccessDialogService,
        FilingStatusDialogService,
        SurveyViewsInstanceService,
        EventService,
        AppSettingsService,
        SessionStorageService
    ]
})
export class DueSurveyDialogComponent extends SurveyViewsInstanceBaseComponent implements OnInit, OnDestroy {
    private destroyRef = inject(DestroyRef);
    private matDialogRef = inject(MatDialogRef<DueSurveyDialogComponent>);
    private dialogData = inject<DueSurveyDialogData>(MAT_DIALOG_DATA);
    public router = inject(Router);
    public route = inject(ActivatedRoute);
    public requestExtensionDialogService = inject(RequestExtensionDialogService);
    public shareSurveyAccessDialogService = inject(ShareSurveyAccessDialogService);
    public filingStatusDialogService = inject(FilingStatusDialogService);
    public surveyViewsInstanceService = inject(SurveyViewsInstanceService);
    public eventService = inject(EventService);
    public appSettingsService = inject(AppSettingsService);
    public sessionStorageService = inject(SessionStorageService);
    public window = inject(WINDOW);
    public paradataEventService = inject(ParadataEventService);

    public dueSurveyDialogData: DueSurveyDialogData | null = null;

    // Signals for reactive state
    private _channel = signal<Subscription | null>(null);

    // Properties that will be set by parent components
    channel$: Subscription | null = null;

    constructor() {
        super(
            inject(Router),
            inject(ActivatedRoute),
            inject(RequestExtensionDialogService),
            inject(ShareSurveyAccessDialogService),
            inject(ParadataEventService),
            inject(FilingStatusDialogService),
            inject(SurveyViewsInstanceService),
            inject(EventService),
            inject(AppSettingsService),
            inject(SessionStorageService),
            inject(WINDOW)
        );

        // Get dialog data from the injected MAT_DIALOG_DATA
        this.dueSurveyDialogData = this.dialogData;

        this.channel$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((event: NavigationEnd) => {
            if (event.url.includes('submit-case')) {
                this.cancel();
            }
        });
    }

    showHelpModal() {
        if (this.survey) {
            this.paradataEventService.add(ParadataEventEnum.HowDoI, this.survey.surveyId);
        }
        window.open(ecorEnv.faqPageLink, '_target');
    }

    ngOnInit() {
        this.paradataEventService.add(ParadataEventEnum.BeginbuttonforAuthenticationCode);
    }

    get safeDialogData(): DueSurveyDialogData {
        return this.dueSurveyDialogData || {
            title: 'Survey Due',
            cancelButtonLabel: 'Close',
            surveys: [],
            date: new Date(),
            active: false
        };
    }


    cancel() {
        this.close('cancel');
    }

    close(value: any) {
        this.matDialogRef.close(value);
    }

    @HostListener('keydown.esc')
    public onEsc() {
        this.close('ESC keydown');
    }

    ngOnDestroy() {
        this.paradataEventService.flushParadataevents();
        const channel = this.channel$;
        if (channel) {
            channel.unsubscribe();
        }
    }
}
